export default __webpack_public_path__ + "static/media/Face-Icon.d2bb553d.svg";